var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adherence-container text-ibm-plex-sans"},[_c('gregorian-calendar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }